import store from '@/store/index'
import { computed } from 'vue'
import { haveProcessingOrder } from '@/api/workPlace/workOrder'
import { REFRESH_LIST, CLOSE_CURRENT_IM, REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'
import { clearStoreChatMsgList } from '@/utils/unReadNum'
import { queryAllGroupId } from '@/api/chat'
import useOrder from '@/views/WorkPlace/components/WorkOrder/hooks/useOrder.js'

const chartId = computed(() => store.state.workOrder.chartId)
export default function useCustomIM(customEvent, param) {
  switch (customEvent) {
    case '280001':
      handleWorkorder()
      break
    case '280002':
      handleAlarm(param)
      break
    case '280003':
      // handleShiftStatus()
      break
    case '280004':
      useCloseIM(param)
      break
    case '280005':
      untreatedNumsChange(param)
      break
    case '280006':
      handleAutoRest(true)
      break
    case '280007':
      handleAutoRest(false)
      break
    case '280008':
      refeshGroupMain(param)
      break
    case '280009':
      handleInstantWorkOrder(param)
      break
    case '280010':
      handleCallSummary(param)
      break
    default:
      break
  }
}
const handleWorkorder = () => {
  // 工单分配变更
  REFRESH_LIST?.emit()
}
const handleAlarm = param => {
  // 新增预警提醒消息
  const alarmInfo = store.getters.alarmInfo || []
  alarmInfo.push(param)
  store.commit('alarm/SET_ALARM_INFO', alarmInfo)
}
const handleShiftStatus = () => {
  //强制下线之后，重新获取当前坐班状态
  store.commit('workOrder/SET_CHART_ID')
  REFRESH_LIST?.emit()
  store.dispatch('user/getUserInfo')
  // 初始化群组信息
  store.commit('initChatState')
  clearStoreChatMsgList()
}
const useCloseIM = async param => {
  const {
    ucPatientId,
    ucDoctorId,
    guideConsultGroupId,
    doctorPatientGroupId,
    assistantPatientGroupId,
    doctorDaGroupId
  } = param
  const groupId = guideConsultGroupId || doctorPatientGroupId || assistantPatientGroupId
  if (!ucPatientId) return
  const params = {
    ucPatientId,
    ucDoctorId
  }
  const res = await haveProcessingOrder(params)
  if (res) return
  const groupIds = [
    guideConsultGroupId,
    doctorPatientGroupId,
    assistantPatientGroupId,
    doctorDaGroupId
  ]
  store.dispatch('clearAllMsg', groupIds)
  if (groupId === chartId.value) {
    CLOSE_CURRENT_IM?.emit()
  }
}

// 即时工单
const handleInstantWorkOrder = param => {
  console.log('收到即时工单推送', param)
  const instantInfo = store.getters.instantOrderList || []
  instantInfo.push(param)
  store.commit('instant/SET_INSTANT_LIST', instantInfo)
}

// 虚拟入群
const refeshGroupMain = async param => {
  console.clear()
  console.log(280008, param)
  const dealingGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
  const dealingWorkOrderId = computed(
    () => store.state.workOrder.workOrderGroupInfo?.targetWorkOrder?.workOrderId
  )
  if (
    dealingWorkOrderId.value === param.workOrderID ||
    dealingGroupInfo.value.dealWorkOrderList.some(item => item.workOrderId === param.workOrderID)
  ) {
    console.log('28008虚拟入群页面刷新')
    const data = await queryAllGroupId()
    store.commit('rollBack/SET_GROUP_IDS_SELF', data)
    // 更新处理中列表
    const { onResetFetch } = useOrder()
    onResetFetch()
    // 更新群聊信息
    // REFRESH_MAIN?.emit()
  }
}

// 自动休息开关
const handleAutoRest = async status => {
  if (status) {
    // 重新获取坐班状态
    await store.dispatch('user/queryShiftStaus')
  } else {
    // 自动休息倒计时置空
    store.commit('rollBack/SET_ROUND_INSTANCE', {
      timer: 'AUTO_REST',
      callBackTime: null
    })
  }
}

// 医助待处理工单回滚
const untreatedNumsChange = async param => {
  console.log('【280005】拒收数变更', param)
  const lastStatusConfig = computed(() => store.state.user.shiftStatusConfig)
  const { currentContinueUntreatedTimes, doctorAssistantContinueUntreatedTimes } = param
  store.commit('user/SET_SHIFT_STATUS_CONFIG', {
    ...lastStatusConfig.value,
    currentContinueUntreatedTimes,
    doctorAssistantContinueUntreatedTimes
  })
  // 变更为坐班中（休息）
  if (parseInt(currentContinueUntreatedTimes) >= parseInt(doctorAssistantContinueUntreatedTimes)) {
    store
      .dispatch('user/shiftStatusAutoChange', {
        status: 1,
        reason: '多次分配未处理'
      })
      .then(() => {
        store.commit('workOrder/SET_CHART_ID')
        REFRESH_LIST?.emit()
        store.dispatch('user/getUserInfo')
        store.commit('initChatState')
        clearStoreChatMsgList()
      })
      .catch(() => {
        store.dispatch('user/queryShiftStaus')
      })
  }
}

// 通话小结待办
const handleCallSummary = param => {
  console.log('280010-----通话小结待办', param)
  store.commit('workOrder/SET_TODO_LIST_VISIBLE', true)
}
